module.exports = __webpack_public_path__ + "9c6063e7906ec7ed60ca56a6056fca0a.glb";